// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"51":"f89c82c2","226":"5430a609","853":"e8f3297e"}[chunkId] + ".css";
};